/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import React, { FC, useEffect, useMemo, useRef } from 'react';
import { useStyles } from './style';
import { TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { debounce } from 'lodash';
import { MagnifyingGlass } from '@phosphor-icons/react'

interface InInputSearch {
  search: (e: any) => void;
  onChange: (e: any) => void;
  placeholder: string;
  value?: string;
  timeoutValue?: number;
}

const InputSearch: FC<InInputSearch> = ({ search, onChange, placeholder, value, timeoutValue = 1000 }) => {
  const classes = useStyles();
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  const updateValue = useMemo(
    () =>
      debounce((nextValue: string) => {
        onChangeRef.current({ target: { value: nextValue } });
      }, timeoutValue),
    [timeoutValue]
  );

  useEffect(() => {
    return () => {
      updateValue.cancel();
    };
  }, [updateValue]);

  const handleFilterChange = (e: any) => {
    updateValue(e.target.value);
  };

  return (
    <>
      <TextField
        defaultValue={value}
        placeholder={placeholder}
        classes={{
          root: classes.input,
        }}
        name="input-search"
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <>
              <MagnifyingGlass onClick={search} className={classes.iconButton} />
            </>
          ),
        }}
        onChange={handleFilterChange}
        onBlur={(e: any) => {
          updateValue.cancel();
          onChange(e);
        }}
      />
    </>
  );
};

export default InputSearch;
